"use client";

import { useRouter } from "next/navigation";
import { ArrowRight } from "lucide-react";
import {
  setGuestCareerStage,
  type CareerStageValue,
} from "@/lib/guestCareerStage";

const OPTIONS: Array<{
  value: CareerStageValue;
  title: string;
  description: string;
}> = [
  {
    value: "new_grad",
    title: "就活で練習する",
    description: "これから社会人になる方・第二新卒の方",
  },
  {
    value: "mid_career",
    title: "転職で練習する",
    description: "すでに働いた経験がある方",
  },
];

// ホーム画面の練習タイプ導線ボタン。選んだ練習タイプを一時保存して練習体験へ進める。
export default function CareerStageEntry() {
  const router = useRouter();

  const handleSelect = (stage: CareerStageValue) => {
    setGuestCareerStage(stage);
    router.push("/practice?questionId=1");
  };

  return (
    <section className="px-5 md:px-10 py-6 md:py-8">
      <div className="max-w-4xl mx-auto">
        <div className="custom-shadow rounded-2xl bg-white p-5 md:p-8">
          <h2 className="text-2xl font-bold text-center mb-2">
            あなたに合った面接練習を始めましょう
          </h2>
          <p className="text-center mb-6 leading-relaxed">
            就活・転職それぞれに合わせた質問とフィードバックを用意しています。
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {OPTIONS.map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => handleSelect(opt.value)}
                className={`custom-shadow-pink-sm hover-lift-pink relative rounded-full ${opt.value === "new_grad" ? "bg-accent" : "bg-primary-300"} text-white text-center py-3 pl-4 pr-12`}
              >
                <span className="block text-xl font-bold">{opt.title}</span>
                <span className="block text-sm mt-2 leading-relaxed text-white font-bold">
                  {opt.description}
                </span>
                <ArrowRight className="absolute right-5 top-1/2 -translate-y-1/2 w-6 h-6" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
